export default menuMobileBtn => {
    // console.log('menuMobileBtn');
    const body = document.querySelector('body');
    const menuHeaderContainer = document.querySelector('.menu-header-container');

    function openMenuMobile() {
        menuMobileBtn.classList.add('open');
        menuMobileBtn.classList.remove('icon-menu-close');
        menuMobileBtn.classList.add('icon-menu-open');
        menuHeaderContainer.classList.add('open');
        body.classList.add('oh');



        if (document.querySelectorAll('.submenu-mobile .item-submenu.open').length > 0) {
            let menu_items = document.querySelectorAll('.submenu-mobile .item-submenu.open');
            for (let i = 0; i < menu_items.length; i++) {
                menu_items[i].classList.remove('open');
            }
        }
    }

    function closeMenuMobile() {
        menuMobileBtn.classList.remove('open');
        menuMobileBtn.classList.remove('icon-menu-open');
        menuMobileBtn.classList.add('icon-menu-close');
        menuHeaderContainer.classList.remove('open');
        body.classList.remove('oh');
    }

    menuMobileBtn.addEventListener('click', () => {
        if (!menuMobileBtn.classList.contains('open')) {
            openMenuMobile();
        } else {
            closeMenuMobile();
        }
    });
};
